import { render, staticRenderFns } from "./appPlug.vue?vue&type=template&id=8196854c&scoped=true"
import script from "./appPlug.vue?vue&type=script&lang=js"
export * from "./appPlug.vue?vue&type=script&lang=js"
import style0 from "./appPlug.vue?vue&type=style&index=0&id=8196854c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8196854c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8196854c')) {
      api.createRecord('8196854c', component.options)
    } else {
      api.reload('8196854c', component.options)
    }
    module.hot.accept("./appPlug.vue?vue&type=template&id=8196854c&scoped=true", function () {
      api.rerender('8196854c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/appPlug.vue"
export default component.exports